
<button mat-raised-button color="accent" (click)="logout()" class="fixedTop">
    logout
</button>
<header class="px-3 py-2 bg-dark text-white">
    <div class="container">
        <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
            <a href="/" class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-white text-decoration-none">
                <div class="flex flex-wrap text-center">
                    <img [src]="imgThumbnail || defaultThumbnail" alt="" class="img-thumbnail m-2 rounded-pill"
                        onerror="this.src='assets/img/user_default.png'">
                    <h4 class="navbar-brand d-inline">Welcome {{role | uppercase}} : {{firstName}} {{lastName}}</h4>
                </div>
            </a>

            <ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
                <li>
                    <a [routerLink]="[ 'leaderboard' ]" routerLinkActive="text-white" class="nav-link text-secondary ">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            leaderboard
                        </mat-icon>
                        Leaderboard
                    </a>
                </li>

                <li>
                    <a [routerLink]="[ 'batch' ]" routerLinkActive="text-white" class="nav-link text-secondary">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            supervisor_account
                        </mat-icon>
                        View Batch
                    </a>
                </li>

                <li>
                    <a [routerLink]="[ 'givePoint' ]" routerLinkActive="text-white" class="nav-link text-secondary">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            auto_awesome
                        </mat-icon>
                        Give Points
                    </a>
                </li>

                <li>
                    <a [routerLink]="[ 'assignBatch' ]" routerLinkActive="text-white" class="nav-link text-secondary">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            assignment_return
                        </mat-icon>
                        Assign Batch
                    </a>
                </li>

                <li>
                    <a [routerLink]="[ 'profile' ]" routerLinkActive="text-white" class="nav-link text-secondary">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            manage_accounts
                        </mat-icon>
                        Edit Profile
                    </a>
                </li>

                <li>
                    <a [routerLink]="[ 'addPrize' ]" routerLinkActive="text-white" class="nav-link text-secondary">
                        <mat-icon class="bi d-block mx-auto mb-1" width="24" height="24">
                            emoji_events
                        </mat-icon>
                        Add Prize
                    </a>
                </li>
            </ul>
        </div>
    </div>
</header>


<!-- <nav class="navbar navbar-expand navbar-light bg-light d-flex flex-row flex-wrap my-3">

    <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a [routerLink]="[ 'leaderboard' ]" routerLinkActive="active" class="nav-link">Leaderboard</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="[ 'batch' ]" routerLinkActive="active" class="nav-link">View Batch</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="[ 'givePoint' ]" routerLinkActive="active" class="nav-link">Give away Revature
                        Point</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="[ 'assignBatch' ]" routerLinkActive="active" class="nav-link">Assign to batch</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="[ 'profile' ]" routerLinkActive="active" class="nav-link">Edit my profile</a>
                </li>

                <li class="nav-item">
                    <a [routerLink]="[ 'addPrize' ]" routerLinkActive="active" class="nav-link">Add prize</a>
                </li>

                <li class="nav-item">
                    <button mat-button color="accent" (click)="logout()" class="flex-end">logout</button>
                </li>

            </ul>
        </div>
    </div>
</nav> -->

<div class="background-view">
    <router-outlet></router-outlet>
</div>